import { render, staticRenderFns } from "./receiveDetail.vue?vue&type=template&id=6b7507d0&scoped=true"
import script from "./receiveDetail.vue?vue&type=script&lang=js"
export * from "./receiveDetail.vue?vue&type=script&lang=js"
import style0 from "./receiveDetail.vue?vue&type=style&index=0&id=6b7507d0&lang=scss"
import style1 from "./receiveDetail.vue?vue&type=style&index=1&id=6b7507d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7507d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7507d0')) {
      api.createRecord('6b7507d0', component.options)
    } else {
      api.reload('6b7507d0', component.options)
    }
    module.hot.accept("./receiveDetail.vue?vue&type=template&id=6b7507d0&scoped=true", function () {
      api.rerender('6b7507d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/couponManage/receiveDetail.vue"
export default component.exports